import React from "react";
import { Link } from "react-router-dom";
import ROUTES_ENUMS from "routes/url.enum";

const Footer = () => {
  return (
    <footer className="flex flex-col items-center px-8 py-6 w-full bg-black text-white max-md:px-5 max-md:mt-10 max-md:max-w-full">
      <div className="w-full flex flex-col md:flex-row md:justify-between md:items-start gap-8 max-md:gap-6 max-w-6xl mx-auto">
        <div className="flex flex-col mb-4 md:mb-0">
          <h2 className="text-lg font-bold mb-2">RL Tours and Travels</h2>
          <p className="text-sm text-gray-400 max-w-xs">
            Explore India’s best destinations with us. Beach, city, hill station, wildlife, heritage & luxury tours.
          </p>
        </div>
        <div className="flex flex-col mb-4 md:mb-0">
          <h3 className="font-semibold mb-2">Quick Links</h3>
          <ul className="text-sm text-gray-400 space-y-1">
            <li><Link to="/about-us" className="hover:text-orange-400 transition">About Us</Link></li>
            <li><Link to="/categories" className="hover:text-orange-400 transition">Categories</Link></li>
            <li><Link to="/top-packages" className="hover:text-orange-400 transition">Top Packages</Link></li>
            <li><Link to="/contact-us" className="hover:text-orange-400 transition">Contact Us</Link></li>
            <li><Link to="/faq" className="hover:text-orange-400 transition">FAQ</Link></li>
            <li><Link to={ROUTES_ENUMS.TERMS_CONDITION} className="hover:text-orange-400 transition">Terms & Condition</Link></li>
          </ul>
        </div>
        <div className="flex flex-col mb-4 md:mb-0">
          <h3 className="font-semibold mb-2">Contact</h3>
          <ul className="text-sm text-gray-400 space-y-1">
            <li>Email: <a href="mailto:rltourism@gmail.com" className="hover:text-orange-400 transition">rltourism@gmail.com</a></li>
            <li>Phone: <a href="tel:9620178625" className="hover:text-orange-400 transition">9620178625</a></li>
            <li>WhatsApp: <a href="https://wa.me/9148570818" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition">9148570818</a></li>
          </ul>
        </div>
        <div className="flex flex-col">
          <h3 className="font-semibold mb-2">Follow Us</h3>
          <div className="flex gap-3">
            <a href="https://www.facebook.com/share/1BsDewHRzU/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition">Facebook</a>
            <a href="https://www.instagram.com/rltourism?igsh=MTBpdmc0YTk3d2ZhNw==" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition">Instagram</a>
            <a href="http://linkedin.com/in/r-l-tours-and-travels-9596bb381" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition">LinkedIn</a>
          </div>
        </div>
      </div>
      <hr className="w-full border-t border-gray-700 my-6" />
      <div className="text-base font-light mb-2 text-gray-400 text-center">
        © 2024 | All rights are reserved
      </div>
    </footer>
  );
};
export default Footer;
